import { Component, Input, OnInit, TemplateRef } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbDate, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  NgWizardConfig,
  NgWizardService,
  StepChangedArgs,
  StepValidationArgs,
  STEP_STATE,
  THEME,
} from "ng-wizard";
import { of } from "rxjs";
import { DateFormateService } from "src/app/services/date-formate.service";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { FrequencyModel } from "../../shared/models/frequency";
import {
  ApprovedAchievementModel,
  LoyaltyTargetModel,
  LoyaltyTargetProductWiseModel,
  PointStructureModel,
  PointStructureProductWiseModel,
  SalesAchievementModel,
  TargetAchievementModel,
  UserSaleAchivementModel,
  UserTargetAndPointStructureModel,
} from "../../shared/models/target-achievement";
import { FrequencyProvider } from "../../shared/providers/frequency.provider";
import { AdminDataProvider } from "../../shared/providers/master-provider/admin-data.provider";
import { TargetAchievementProvider } from "../../shared/providers/target-achivement.provider";
import { Location } from "@angular/common";
import { searchUsers } from "../../shared/models/mock-data";
import { RegionProvider } from "../../shared/providers/region.provider";
import { UnitsProvider } from "../../shared/providers/units.provider";
import { ChannelProvider } from "../../shared/providers/channel.provider";
import { GeographyProvider } from "../../shared/providers/geography.provider";
import { ChannelModel } from "../../shared/models/channel";
import { RegionModel } from "../../shared/models/region";
import { UnitsModel } from "../../shared/models/units";
import { UserRoleModel } from "../../shared/models/user-roles";
import { XlsxService } from "src/app/services/xlsx/xlsx.service";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";
import {
  BrandCategoryModel,
  BrandModel,
  ProductModel,
} from "../../shared/models/brands";
import { GeographyModel } from "../../shared/models/geography";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { RolesProvider } from "../../shared/providers/roles.provider";
import { RolesModel } from "../../shared/models/roles";
import { XlsxViewComponent } from "src/app/shared/xlsx-view/xlsx-view.component";
import { AlertService } from "src/app/shared/providers/AlertProvider";

import * as XLSX from "xlsx";
import { UploadZipService } from "src/app/services/upload-zip/upload-zip.service";
import { invalid } from "@angular/compiler/src/render3/view/util";
import * as moment from "moment";
import { StateModel } from "../../shared/models/state";
import { StateProvider } from "../../shared/providers/state.provider";
@Component({
  selector: "app-add-target-achievements",
  templateUrl: "./add-target-achievements.component.html",
  styleUrls: ["./add-target-achievements.component.scss"],
})
export class AddTargetAchievementsComponent implements OnInit {
  submittedLevels: any = { isSubmitted: false, state: "engagement" };
  addForm: FormGroup;
  submitted = false;
  submitted1 = false;
  achievementSubmitted = false;
  loading = false;
  searchPage = 1;
  searchPage1 = 1;
  searchPage2 = 1;
  pointsCalcStatus = "";
  userTargetForm: FormGroup;
  achievementForm: FormGroup;
  saleAchievementForm: FormGroup;
  items: FormArray;
  achmnt: any;
  frequency: FrequencyModel[];
  @Input() targetModel: TargetAchievementModel = new TargetAchievementModel();
  @Input()
  userTargetPoint: UserTargetAndPointStructureModel = new UserTargetAndPointStructureModel();
  userAchievement: UserSaleAchivementModel = new UserSaleAchivementModel();
  outletmasterSelected: boolean = false;
  filterParams;
  geography: GeographyModel[];
  roles: UserRoleModel[];
  brands: BrandModel[];
  products: ProductModel[];
  brandCategories: BrandCategoryModel[];
  productsPointSection: ProductModel[];
  brandCategoriesPointSection: BrandCategoryModel[];
  disable: boolean = true;
  filteredDetailsFortarget: any = {
    regions: [],
    channels: [],
    user_roles: [],
    states: [],
    city: [],
  };
  filteredDetailsForpoint: any = {
    regions: [],
    channels: [],
    user_roles: [],
    states: [],
    city: [],
  };
  productsList: any = [];
  getPaginationCount;
  getPaginationCount1;
  getAssignedPaginationCount;
  searchUsers = searchUsers;
  UserDetails: any;
  UserDetails1: any;
  selectedUserData: any = [];
  units: any = [];
  channels: ChannelModel[];
  regions: RegionModel[];
  targetId;
  excelChecked: boolean = false;
  formData: any = {};
  productArray: any = [];
  productValues: [];
  excel_data: any;
  excel_data1: any;
  getAssignedUsers;
  headerText: any = "";
  searchText: string = "";
  getLoyaltyTargets: LoyaltyTargetModel[];
  loyaltyTargetsExcelData: LoyaltyTargetModel[];
  getPointStructure: PointStructureModel[];
  getSalesAchievement: SalesAchievementModel[];
  singleProductObject = {
    category: "",
    category_id: "",
    channel_id: "",
    operator: "",
    points: "",
    qty: "",
    state: "",
    unit: "",
    unit_id: "",
    region_id: "",
  };
  filteredBrands: any = [];
  addbrandCheck = {
    selection: 1,
    tab: "target",
    genericPoint: null,
  };
  allUsers: RolesModel[];
  openExcelDetails: any = {
    status: 1,
    uploaded: false,
    excelFileName: [],
  }; // status: 1 is target and 2 is points
  tempOptionModel;
  sildeModelPlaceHolder = "";
  cities: any[];
  states: any[];
  isSideModelEnable: any = {
    target: false,
    point: false,
  };
  excelData: LoyaltyTargetModel[];
  minDate: { year: any; month: any; day: any; };
  pointCreditStatus: any;
  date = new Date;
  year_opation;
  month_error = true;
  month;
  testxxx;
  isdisplay = [true, true, true, true, true, true, true, true, true, true, true, true];
  selectedRegion;
  filterStateByRegion: any = [];
  target_Id;
  creditPointsFlag: boolean = false

  constructor(
    public targetAchivementProvider: TargetAchievementProvider,
    public modalService: NgbModal,
    public fb: FormBuilder,
    public ngWizardService: NgWizardService,
    public adminDataProvider: AdminDataProvider,
    public apiService: ApiService,
    public apiConfig: ApiConfiguration,
    public router: Router,
    private formBuilder: FormBuilder,
    public frequencyProviders: FrequencyProvider,
    private route: ActivatedRoute,
    private formateDate: DateFormateService,
    private _location: Location,
    public regionProviders: RegionProvider,
    public unitsProviders: UnitsProvider,
    public channelProviders: ChannelProvider,
    public geoProviders: GeographyProvider,
    private xlsx: XlsxService,
    public exportExcelService: ExportExcelService,
    private toast: ToastClientService,
    private userRoles: RolesProvider,
    public alertService: AlertService,
    private uploadFile: UploadZipService,
    public stateProvider: StateProvider,
  ) {
    this.year_opation = parseInt(moment(this.date).format("YYYY"))

    // let year = moment(this.date).format("YYYY")
    this.month = moment(this.date).format("MM")
    // this.year_opation = parseInt(moment(this.targetModel.start_date.year).format("YYYY"))

    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };

    this.uploadFile.currentMessage.subscribe(message => {
      if (message.status == 'success') {
        this.showNextStep();
        this.disable = true
      }
    })
  }

  omit_special_char(event) {
    var k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    /*
    https://www.codegrepper.com/code-examples/javascript/keycode+32
    A-Z = 65 to 90
    a-z = 97 to 122
    0-9 = 48 to 57
    dash = 45
    underscore = 95
    backspace = 8
    spacebar = 32
     */
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 45 || k == 95);
  }

  allow_Only_numbers(event) {
    var k = event.charCode;
    return ((k >= 48 && k <= 57));
  }

  ngOnInit() {
    console.log("targetmodel", this.targetId);
    /****Setting form********/
    this.addForm = this.formBuilder.group({
      target_title: ["", Validators.required],
      frequency_id: [""],
      month: ["", [Validators.required]],
      year: ["", [Validators.required]],
      point_display: ["", Validators.required],
      target_description: [""],
      // target_img: [""],
      // announcement_image: [""],
      announcement: [""],
    });


    this.userTargetForm = this.formBuilder.group({
      userTargetExcel: ["", Validators.required],
      channel_id: ["", Validators.required],
      region_id: ["", Validators.required],
      state_code: ["", Validators.required],
      items: new FormArray([this.createItem()], this.isNameDup()),
      productItems: new FormArray([this.createProductItem()], this.isNameDup()),
    });

    this.achievementForm = this.formBuilder.group({
      userAchievementExcel: ["", Validators.required],
    });

    this.getAllRoles();
    this.getAllBrands();
    this.getProducts();
    this.getAllCategories();

    this.userTargetPoint.points_based = 1;

    this.headerText = 'Add';
    this.route.queryParamMap.subscribe((paramMap) => {
      console.log("paramMap", paramMap);
      if (!paramMap.has("targetId")) {
        this.router.navigateByUrl("/hubAdmin/add-target-achievements");
        return;
      }
      this.targetId = paramMap.get("targetId");
      if (typeof this.targetId !== undefined) {
        this.getTarget(paramMap.get("targetId"));
        this.getLoyaltyUserByTarget(this.targetId);
        this.getTargetPageCount(this.targetId);
        this.getAllSaleAchievements(this.targetId, this.filteredDetailsForApi);
        this.getAllLoyaltyTargetReportsCategories();
        this.headerText = "Edit";
      } else {
        this.headerText = "Add";
      }
    });

  }

  /************POINT STRUCTURE FORM*******************/

  // convenience getters for easy access to form fields
  get f1() {
    return this.userTargetForm.controls;
  }

  get f2() {
    return this.achievementForm.controls;
  }
  get t() {
    return this.f1.items as FormArray;
  }

  get t1() {
    return this.f1.productItems as FormArray;
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      brand_id: ["", Validators.required],
      channel_id: [""],
      operator: ["", Validators.required],
      points: ["", Validators.required],
      qty: ["1", Validators.required],
      min: ["0", Validators.required],
      max: ["0", Validators.required],
      label: ["", Validators.required],
      unit_id: ["", Validators.required], //1 = Case, 2 = Litre
      region_id: [""],
    });
  }

  createProductItem(): FormGroup {
    return this.formBuilder.group({
      brand_id: ["", Validators.required],
      channel_id: [""],
      operator: ["", Validators.required],
      points: ["", Validators.required],
      qty: ["1", Validators.required],
      min: ["0", Validators.required],
      max: ["0", Validators.required],
      label: ["", Validators.required],
      unit_id: ["", Validators.required], //1 = Case, 2 = Litre
      region_id: [""],
    });
  }

  operators = [{ id: "1", value: "=" }];

  addItem(item): void {
    this.items = this.userTargetForm.get("items") as FormArray;
    this.items.push(this.createItem());
    var selected = this.userTargetForm.get("items").value;
    console.log(selected);
  }

  addItemProduct(item): void {
    this.items = this.userTargetForm.get("productItems") as FormArray;
    this.items.push(this.createProductItem());
    var selected = this.userTargetForm.get("productItems").value;
    console.log(selected);
  }

  removeItem(i): void {
    this.t.removeAt(i);
  }

  removeProductItem(i): void {
    this.t1.removeAt(i);
  }
  getState() {
    this.filterStateByRegion = []
    // console.log("@#$",this.selectedRegion)
    this.apiService.get(this.apiConfig.configGetStates).subscribe((res: any) => {
      console.log("regions", this.regions)
      res.data.map((r: any) => {
        if (r.region_id == this.selectedRegion) {
          this.filterStateByRegion.push(r)

        }
      })
      console.log("@#$", this.filterStateByRegion)
    })
  }

  onSubmit1() {
    let selectedStateArray = [];
    let selectedRegion = [];
    // debugger
    this.filteredDetails1.states_list.forEach(e => {
      selectedStateArray.push(e.id)
    });

    this.filteredDetails1.regions.forEach(e => {
      selectedRegion.push(e.id)
    });

    //console.log(selectedStateArray.toString());

    this.submitted1 = true;
    console.log(this.userTargetPoint);
    // stop here if form is invalid
    this.userTargetPoint.sku_based =
      this.userTargetPoint.sku_based == true ? 1 : 0;
    if (this.userTargetPoint.sku_based == 1) {
      this.userTargetForm.controls['items'].disable();
      this.userTargetForm.controls['items'].updateValueAndValidity();
      this.userTargetForm.controls['productItems'].enable();
      this.userTargetForm.controls['productItems'].updateValueAndValidity();
    } else {
      this.userTargetForm.controls['items'].enable();
      this.userTargetForm.controls['items'].updateValueAndValidity();
      this.userTargetForm.controls['productItems'].disable();
      this.userTargetForm.controls['productItems'].updateValueAndValidity();
    }

    // this.userTargetPoint.points_based =
    //   this.userTargetPoint.points_based == true ? 1 : 0;

    // if (this.userTargetPoint.points_based == 1) {
    //   this.userTargetForm.controls['items'].enable();
    //   this.userTargetForm.controls['items'].updateValueAndValidity();
    // } else {
    //   this.userTargetForm.controls['items'].disable();
    //   this.userTargetForm.controls['items'].updateValueAndValidity();
    // }

    // if (this.userTargetForm.invalid) {
    //   return;
    // }

    // this.filteredDetailsForApi.states = this.filteredDetails1.states
    //     .map((i) => i.id)
    //     .join(",")
    //     .toString();

    // console.log('gov',this.filteredDetailsForApi.states);

    this.userTargetPoint.id = this.targetId;
    this.userTargetPoint.region_id = selectedRegion.toString();
    this.userTargetPoint.state_id = selectedStateArray.toString();
    this.userTargetPoint.channel_id = this.userTargetForm.controls["channel_id"].value;
    if (this.userTargetPoint.points_based == 1) {
      if (this.userTargetPoint.sku_based == 1) {
        this.userTargetPoint.point_structure = this.userTargetForm.controls["productItems"].value;
      }
      else {
        this.userTargetPoint.point_structure = this.userTargetForm.controls[
          "items"
        ].value;
      }
    }
    console.log(this.userTargetPoint);

    //this.newSubmit(this.userTargetPoint);
    this.uploadMultiData(this.userTargetPoint);
    // this.onReset1();
  }

  onReset1() {
    // reset whole form back to initial state
    this.submitted1 = false;
    this.userTargetForm.reset();
    this.t.clear();
    this.t1.clear();
    this.t.push(this.createItem());
    this.t1.push(this.createProductItem());
  }

  onClear1() {
    // clear errors and reset ticket fields
    this.submitted1 = false;
    this.userTargetForm.reset();
    this.t.reset();
    this.t1.reset();
  }

  onAchievementSubmit() {
    this.achievementSubmitted = true;
    // stop here if form is invalid
    if (this.achievementForm.invalid) {
      return;
    }
    console.log(this.achievementForm);
    console.log(this.userAchievement);
    this.uploadMultiData1(this.userAchievement)
    this.onReset2();
  }

  onReset2() {
    // reset whole form back to initial state
    this.achievementSubmitted = false;
    this.achievementForm.reset();
    // this.t.clear();
    // this.t.push(this.createItem());
  }

  onClear2() {
    // clear errors and reset ticket fields
    this.submitted1 = false;
    this.achievementForm.reset();
    // this.t.reset();
  }

  onCreditPoints() {
    let payload = {
      "target_id": "", "batch_name": ""
    }
    payload.target_id = this.targetId;
    payload.batch_name = "pointscredit"
    this.apiService
      .post(this.apiConfig.targetruninsert, payload)
      .subscribe((res: any) => {
        if (res.status == 201 || res.status == 200) {
          this.toast.Success("Points Credit Request Added successfully");
          this.showNextStep();
          this.creditPointsFlag = true
          this.getAllLoyaltyTargetReportsCategories();
        }
      });
  }
  onCalculatePoints() {
    let payload = {
      "target_id": "", "batch_name": ""
    }
    payload.target_id = this.targetId;
    payload.batch_name = "pointscalc"
    this.apiService
      .post(this.apiConfig.targetruninsert, payload)
      .subscribe((res: any) => {
        if (res.status == 201 || res.status == 200) {
          this.toast.Success("Points Calculation Request Added successfully");
          this.pointsCalcStatus = "Submitted";
          this.showNextStep();
        }
      });
    alert(this.targetId);
  }

  /***************************************************/

  ngAfterViewInit() {
    (document.querySelector('.tabSaveBtn') as HTMLElement).style.display = 'none';
  }

  isDisabled = (date: NgbDate, current: { month: number }) => date.day !== 1;

  ngDoCheck() {
    this.frequency = this.frequencyProviders.frequency;
    this.geography = this.geoProviders.geography;
    this.channels = this.channelProviders.channels;
    this.regions = this.regionProviders.regions;
    this.units = this.unitsProviders.units;
    this.allUsers = this.userRoles.roles;
    this.cities = this.regionProviders.cities;
    // let city = this.regionProviders.cities;
    let states = this.regionProviders.states;
    this.states_list = this.stateProvider.state;
    // console.log("list",this.states_list)

    if (states) {
      this.formateStates(states);
    }
  }
  formateStates(states) {
    let filteredStates = states.filter((ele) => (ele.id = ele.state_code));
    this.states = filteredStates;
  }
  config: NgWizardConfig = {
    selected: 0,
    anchorSettings: { anchorClickable: true, enableAllAnchors: true },
    theme: THEME.default,
    toolbarSettings: {
      toolbarExtraButtons: [],
    },
  };

  firstTab() { }

  addMore() {
    this.singleProductObject.channel_id = this.formData.channel_id;
    this.singleProductObject.region_id = this.formData.region_id;
    this.productArray.push(
      JSON.parse(JSON.stringify(this.singleProductObject))
    );
    console.log(this.productArray);
  }

  removeInput(i) {
    this.productArray.splice(i, 1);
  }

  getProduct(value, i) {
    let catArray = value.split(",");
    this.productArray[i].brand_category_id = catArray[0];
    this.productArray[i].brand_name = catArray[1];
    console.log(this.productArray);
  }

  getQuantity(value, i) {
    this.productArray[i].qty = value;
  }

  getUnit(value, i) {
    let unitArray = value.split(",");
    this.productArray[i].unit_id = unitArray[0];
    this.productArray[i].unit = unitArray[1];
  }

  getOperator(value, i) {
    this.productArray[i].operator = value;
  }

  getPoints(value, i) {
    this.productArray[i].points = value;
  }

  uploadFileEvent() {
    document.getElementById("my-file-selector").click();
  }
  excelFileName: string;

  uploadXlsx(eve, status) {
    if (eve.target.files) {
      this.excelFileName = eve.target.files[0].name;
    }
    this.xlsx.uploadXlsx(eve).then((res: any) => {
      this.excel_data = res.data;
      console.log(this.excel_data);
      this.userTargetPoint.excel_data = this.excel_data;
      let found = this.userTargetPoint.excel_data.findIndex(f => Object.keys(f).length === 0);
      if (found >= 0) {
        let error = 'Please delete extra rows or merged rows and upload again at line ' + (found + 2);
        this.toast.Error(error);
        this.alertService.error(error);
        this.clearSuccess();
        return;
      }

      this.xlsxView(res)
    });
  }


  uploadXlsx1(eve) {
    this.xlsx.uploadXlsx(eve).then((res: any) => {
      this.excel_data1 = res.data;
      console.log(this.excel_data1);
      this.userTargetPoint.point_excel_data = this.excel_data1;
    });
  }

  async onSelectFile(ev) {
    console.log("hello")

    if (ev.target.files.length == 0) {
      this.disable = true;
    }
    let workBook = null;
    let jsonData = null;
    let jsonData1 = null;
    const reader = new FileReader();
    const reader1 = new FileReader();
    const file = ev.target.files[0];
    let rowData: any = {};
    let base64Data = null;
    reader1.readAsDataURL(file);
    reader1.onload = (event) => {
      const data1 = reader1.result;
      base64Data = data1;
    };
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: "binary" });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      var first_sheet_name = workBook.SheetNames[1];
      var worksheet = workBook.Sheets[first_sheet_name];
      var secondSheet = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      const dataString = jsonData;

      for (let key of Object.keys(dataString)) {
        const result = Array.isArray(dataString[key]);
        if (result) {
          dataString[key].forEach((element: any, i) => {
            for (const keys of Object.keys(element)) {
              var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
              let match = format.test(element[keys]);
              if (match) {
                let error = keys + ' Contains Some Special Characters';
                this.toast.Error(error);
                this.disable = true;
                // var a = ev.target.files;
                this.achievementSubmitted = false;
                this.achievementForm.reset();
                //  console.log(match);
                //  console.log('g');

                return;
              }
              else {
                //this.disable = false;
              }


            }
          });
        }

      }

      let key = Object.keys(dataString);
      let key1 = key[0];
      let excelData = dataString[key1];
      this.userAchievement.achievement_category_data = jsonData["Sales Achievement Category Wise"];
      this.userAchievement.achievement_product_data = jsonData["Sales Achievement Product Wise"];
      this.userAchievement.id = this.targetId;
    };

    if (typeof (this.userAchievement.achievement_category_data) != "undefined") {
      if (this.userAchievement.achievement_category_data.length > 0) {
        let found = this.userAchievement.achievement_category_data.findIndex(f => Object.keys(f).length === 0);
        if (found >= 0) {
          let error = 'Please delete extra rows or merged rows and upload again in Sales Achievement Category Wise at line ' + (found + 2);
          this.toast.Error(error);
          this.alertService.error(error);
          this.clearSuccess();
          return;
        }
      }
    }

    if (typeof (this.userAchievement.achievement_product_data) != "undefined") {
      if (this.userAchievement.achievement_product_data.length > 0) {
        let found1 = this.userAchievement.achievement_product_data.findIndex(f => Object.keys(f).length === 0);
        if (found1 >= 0) {
          let error = 'Please delete extra rows or merged rows and upload again in Sales Achievement Product Wise at line ' + (found1 + 2);
          this.toast.Error(error);
          this.alertService.error(error);
          this.clearSuccess();
          return;
        }
      }
    }

    this.disable = false;
    reader.readAsBinaryString(file);
  }

  stepStates = {
    normal: STEP_STATE.normal,
    disabled: STEP_STATE.disabled,
    error: STEP_STATE.error,
    hidden: STEP_STATE.hidden,
  };

  getProducts() {
    this.apiService
      .getHeaders(this.apiConfig.getProductsList)
      .subscribe((res: any) => {
        this.products = res.body.data as ProductModel[];
        this.products = this.products.filter((p) => p.is_loyalty == 1);
        this.productsPointSection = res.body.data as ProductModel[];
        this.productsPointSection = this.productsPointSection.filter((p) => p.is_loyalty == 1);
      });
  }

  selectedbrandCategoriesPointSection: any[];

  getAllCategories() {
    this.apiService.getHeaders(this.apiConfig.getAllCategiry).subscribe(
      (res: any) => {
        this.brandCategories = res.body.data as any[];
        this.brandCategoriesPointSection = res.body.data as any[];
        this.selectedbrandCategoriesPointSection = res.body.data as any[];
      },
      (err) => {
        console.log(err);
      }
    );
  }



  /* wizard section start */
  showPreviousStep(event?: Event) {
    this.ngWizardService.previous();
  }

  showNextStep(event?: Event) {
    this.ngWizardService.next();
  }

  resetWizard(event?: Event) {
    this.ngWizardService.reset();
  }

  setTheme(theme: THEME) {
    this.ngWizardService.theme(theme);
  }

  isValidTypeBoolean: boolean = true;

  stepChanged(args: StepChangedArgs) {
    if (args.step.index == 0) {
      this.submittedLevels.state = "add target";
    } else if (args.step.index == 1) {
      this.submittedLevels.state = "userasign";
    } else if (args.step.index == 2) {
      this.submittedLevels.state = "addQuiz";
    } else if (args.step.index == 3) {
      this.submittedLevels.state = "message";
    }
    if (args.step.title == "Target & Point Sturcture") {
      if (typeof this.targetId !== "undefined") {
        this.getAllApi(this.targetId, this.filteredDetailsForApi);
        this.getAllPointsStructure(this.targetId);
      }
    }
    if (args.step.title == "Sales Achievements") {
      if (typeof this.targetId !== "undefined") {
        this.getAllSaleAchievements(this.targetId, this.filteredDetailsForApi1);
      }
    }
  }
  isValidFunctionReturnsBoolean(args: StepValidationArgs) {
    return true;

  }


  isValidFunctionReturnsObservable(args: StepValidationArgs) {
    return of(true);
  }

  /*******Form Functions*****/

  // convenience getter for easy access to form fields
  get f() {
    return this.addForm.controls;
  }

  backClicked() {
    this.router.navigateByUrl("/hubAdmin/add-target-achievements");
    return;
  }


  setFormModel() {
    this.targetModel.frequency_id = this.addForm.controls['frequency_id'].value;
  }

  getFormModel() {
    this.addForm.controls['frequency_id'].setValue(this.targetModel.frequency_id);
  }

  onSubmit() {

    // this.setFormModel();
    this.submitted = true;
    console.log("addform_status", this.addForm)
    if (this.addForm.invalid) {
      return;
    } else {

      let payload = {

        target_title: this.addForm.controls['target_title'].value,
        target_description: this.addForm.controls['target_description'].value,
        terms_conditions: this.addForm.controls['announcement'].value,
        sel_month: this.addForm.controls['month'].value,
        sel_year: this.addForm.controls['year'].value,
        point_display: this.addForm.controls['point_display'].value,
        frequency_id: 3
      }
      this.apiService
        .post(this.apiConfig.addTargetAchivement, payload)
        .subscribe((res) => {
          this.targetId = res.body.data.data.id;
          // console.log("!@#$%^&*", this.targerId)
          this.toast.Success("Target Details Set Successfully.")
          this.edit(this.targetId);
          this.ngWizardService.next();
          this.addForm.patchValue({ point_display: String(payload.point_display) });

        }, err => {
          this.toast.Error("Data Already Exists")

        })
      return;
      this.submitted = true;
      this.targetModel.sel_month = this.addForm.controls['month'].value;
      // console.log(month);
      this.targetModel.sel_year = this.addForm.controls['year'].value;
      this.targetModel.frequency_id = 3
      // console.log(year)
      // let target = this.addForm.controls['target_title'].value;
      // console.log(target)

    }
    // let startDate = this.addForm.controls['start_date'].value;
    // let endDate = this.addForm.controls['end_date'].value;
    // if (startDate != null && endDate != null) {
    //   this.addForm.controls['start_date'].clearValidators();
    //   this.addForm.controls['end_date'].clearValidators();
    //   this.addForm.controls['start_date'].updateValueAndValidity();
    //   this.addForm.controls['end_date'].updateValueAndValidity();
    // }
    // else {
    //   this.addForm.controls['start_date'].setValidators([Validators.required]);
    //   this.addForm.controls['end_date'].setValidators([Validators.required]);
    //   this.addForm.controls['start_date'].updateValueAndValidity();
    //   this.addForm.controls['end_date'].updateValueAndValidity();
    // }

    // // debugger;
    // // stop here if form is invalid
    // if (this.addForm.invalid) {
    //   return;
    // }
    // console.log(this.targetModel);
    // if (new Date(this.addForm.controls['end_date'].value) < new Date(this.addForm.controls['start_date'].value)) {
    //   this.toast.Error("End Date can\'t before Start date");
    //   return;
    // }
    if (typeof this.targetId !== "undefined") {
      this.targetModel.id = this.targetId;
      if (this.targetAchivementProvider.updateTarget(this.targetModel)) {
        this.showNextStep();
      }
      this.addDates();
    } else {
      if (this.targetAchivementProvider.addTarget(this.targetModel)) {
        this.showNextStep();
      }
      this.addDates();
    }
    this.addDates();

  }

  edit(id) {
    //this.router.navigateByUrl("/hubAdmin/list-target-achievements")
    this.router.navigate(["/hubAdmin/add-target-achievements"], {
      queryParams: { targetId: id },
    });
  }



  newSubmit(payload: UserTargetAndPointStructureModel) {

    this.uploadMultiData(payload);
    this.apiService
      .post(this.apiConfig.createLoyalty, payload)
      .subscribe((res: any) => {
        if (res.status == 201 || res.status == 200) {
          this.toast.Success("Detais Added successfully");
          this.showNextStep();
        }
      });
    console.log(payload);
  }

  uploadAchivement(payload: UserSaleAchivementModel) {
    this.apiService
      .post(this.apiConfig.createSalesAchivement, payload)
      .subscribe((res: any) => {
        if (res.status == 201 || res.status == 200) {
          this.toast.Success("Detais Added successfully");
          this.showNextStep();
        }
      });
    console.log(payload);
  }

  onReset() {
    this.submitted = false;
    this.addForm.reset();
  }

  /******** */

  uploadImg(files, item) {
    let file = files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      let fileToUpload = reader.result;
      if (item == "banner") {
        this.targetModel.target_img = fileToUpload;
      } else if (item == "announcement") {
        this.targetModel.announcement_image = fileToUpload;
      }
    };
  }

  getTarget(id: any) {
    this.apiService
      .getHeaders(this.apiConfig.getTargetAchivementList + "?id=" + id)
      .subscribe((res: any) => {
        this.targetModel = res.body.data as TargetAchievementModel;
        console.log("###", this.targetModel)

        this.addDates();
        this.getFormModel();
      });
  }

  addDates() {
    let dates = {
      start: this.targetModel.start_date.split("-"),
      end: this.targetModel.end_date.split("-"),
    };
    let startDate = {
      year: parseInt(dates.start[0]),
      month: parseInt(dates.start[1]),
      day: parseInt(dates.start[2]),
    };
    let endDate = {
      year: parseInt(dates.end[0]),
      month: parseInt(dates.end[1]),
      day: parseInt(dates.end[2]),
    };
    this.targetModel.start_date = startDate;
    this.targetModel.end_date = endDate;
  }

  /*******************************/
  /**General section */

  getUserAssignment(data) {
    // debugger
    this.apiService
      .post(this.apiConfig.getUserAssignment + "?page=" + this.searchPage, data)
      .subscribe(
        (res: any) => {
          // console.log(res.body);
          let data = res.body.data;
          this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
          if (data) {
            this.UserDetails = data;
            this.UserDetails.forEach((element) => {
              element.isSelected = false;
            });
            if (this.UserDetails.length == 0) {
              this.UserDetails = null;
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  /* Fillter section for target */
  async selectedItem(status, data, serviceId) {
    switch (serviceId) {
      case 1: // roles
        if (status == "target") {
          this.filteredDetailsFortarget.user_roles = await this.formateFillters(
            this.filteredDetailsFortarget,
            data,
            "user_roles"
          );
        } else if (status == "point") {
          this.filteredDetailsForpoint.user_roles = await this.formateFillters(
            this.filteredDetailsForpoint,
            data,
            "user_roles"
          );
        }
        break;
      case 2: // channels
        if (status == "target") {
          this.filteredDetailsFortarget.channels = await this.formateFillters(
            this.filteredDetailsFortarget,
            data,
            "channels"
          );
        } else if (status == "point") {
          this.filteredDetailsForpoint.channels = await this.formateFillters(
            this.filteredDetailsForpoint,
            data,
            "channels"
          );
        }
        break;
      case 3: // resions
        if (status == "target") {
          this.filteredDetailsFortarget.regions = await this.formateFillters(
            this.filteredDetailsFortarget,
            data,
            "regions"
          );
        } else if (status == "point") {
          this.filteredDetailsForpoint.regions = await this.formateFillters(
            this.filteredDetailsForpoint,
            data,
            "regions"
          );
        }
        break;
      case 4: // state
        if (status == "target") {
          this.filteredDetailsFortarget.states = await this.formateFillters(
            this.filteredDetailsFortarget,
            data,
            "states"
          );
        } else if (status == "point") {
          this.filteredDetailsForpoint.states = await this.formateFillters(
            this.filteredDetailsForpoint,
            data,
            "states"
          );
        }
        break;
      case 5: // city
        if (status == "target") {
          this.filteredDetailsFortarget.city = await this.formateFillters(
            this.filteredDetailsFortarget,
            data,
            "city"
          );
        } else if (status == "point") {
          this.filteredDetailsForpoint.city = await this.formateFillters(
            this.filteredDetailsForpoint,
            data,
            "city"
          );
        }
        break;
      default:
        break;
    }
    if (status == "target") {
      if (this.enableOpenSideModelBtn(this.filteredDetailsFortarget)) {
        this.isSideModelEnable.target = true;
      } else {
        this.isSideModelEnable.target = false;
      }
    }
    if (status == "point") {
      if (this.enableOpenSideModelBtn(this.filteredDetailsForpoint)) {
        this.isSideModelEnable.point = true;
      } else {
        this.isSideModelEnable.point = false;
      }
    }
  }
  enableOpenSideModelBtn(array) {
    let isEnable: boolean = true;
    for (let child of Object.keys(array)) {
      if (array[child].length == 0) {
        isEnable = false;
      }
    }
    return isEnable;
  }
  formateFillters(array, data, name) {
    if (data.status == "singleSelect") {
      array[name].push(data.data.id);
      return array[name];
    } else if (data.status == "singleDeselect") {
      array[name].forEach((element, i) => {
        if (element == data.data.id) {
          array[name].splice(i, 1);
        }
      });
      return array[name];
    } else if (data.status == "SelectAll") {
      array[name] = [];
      if (data.data) {
        data.data.forEach((element) => {
          array[name].push(element.id);
        });
      }
      return array[name];
    } else if (data.status == "unSelectAll") {
      array[name] = [];
      return array[name];
    }
  }
  /* Fillter Button click */
  async filterBtnCall() {
    let isvalid = false;
    for (var i in this.filteredDetailsFortarget) {
      if (this.filteredDetailsFortarget[i].length != 0) {
        isvalid = true;
        break;
      }
    }
    if (isvalid) {
      this.searchUsers.filter_search_geography = this.filteredDetailsFortarget.geography;
      this.searchUsers.filter_search_channel = this.filteredDetailsFortarget.channels;
      this.searchUsers.filter_search_region = this.filteredDetailsFortarget.regions;
      this.searchUsers.filter_search_userrole = this.filteredDetailsFortarget.user_roles;
      this.getUserAssignment(this.searchUsers);
    } else {
      alert("Select any filter!");
    }
  }

  /* Filter section */
  checkUncheckAll() {
    for (var i = 0; i < this.UserDetails.length; i++) {
      this.UserDetails[i].isSelected = this.outletmasterSelected;
    }
    this.getCheckedItemList();
  }
  isAllSelected() {
    this.outletmasterSelected = this.UserDetails.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }

  getCheckedItemList() {
    this.selectedUserData = [];
    try {
      for (var i = 0; i < this.UserDetails.length; i++) {
        if (this.UserDetails[i].isSelected)
          this.selectedUserData.push(this.UserDetails[i].id);
      }
      // this.selectedUserData = JSON.stringify(this.selectedUserData);
    } catch (error) { }
  }

  paginationClick(e) {
    console.log(e);
    this.searchPage = e;
    this.getAllApi(this.targetId, this.filteredDetailsForApi);
  }

  paginationClick2(e) {
    console.log(e);
    this.searchPage2 = e;
    this.getAllSaleAchievements(this.targetId, this.filteredDetailsForApi1);
  }

  getAllRoles() {
    this.apiService.getHeaders(this.apiConfig.configGetRoles).subscribe(
      (res: any) => {
        if (res !== null) {
          this.roles = res.body.data;
          if (this.roles !== null) {
            if (this.roles.length > 0) {
              this.roles.forEach((f) => {
                f.name = f.role_icon;
              });
            }
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  /*******************************************************************/

  paginationClick1(e) {
    console.log(e);
    this.searchPage1 = e;
    this.getAllPointsStructure(this.targetId);
  }

  getLoyaltyUserByTarget(targetId) {
    // debugger
    this.apiService
      .getHeaders(
        this.apiConfig.assignedLoyaltyTarget +
        "?page=" +
        this.searchPage +
        "&target_id=" +
        targetId
      )
      .subscribe(
        (res: any) => {
          let data = res.body.data;
          if (data) {
            this.UserDetails1 = data;
            this.UserDetails1.forEach((element) => {
              element.isSelected = false;
            });
            if (this.UserDetails1.length == 0) {
              this.UserDetails1 = null;
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getAllApi(targetId, data) {
    this.apiService
      .getHeaders(
        this.apiConfig.getLoyaltyTargets +
        "?page=" +
        this.searchPage +
        "&target_id=" +
        targetId +
        "&ro_code=" + data.search_string
      )
      .subscribe((res: any) => {
        console.log(res);
        this.getLoyaltyTargets = res.body.data as LoyaltyTargetModel[];
        this.getLoyaltyTargets.forEach((i) => {
          i.isEdit = false;
          i.showDetail = false;
          i.showEdit = false;
          if (i.sku_wise_target.length > 0) {
            i.showEdit = true;
            i.sku_wise_target.forEach((j) => {
              j.isEdit = false;
            });
          }
        });
        this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
        // this.getTargetPageCount(targetId);
      });
  }

  getAllPointsStructure(targetId) {
    this.apiService
      .getHeaders(
        this.apiConfig.getPointStructure +
        "?page=" +
        this.searchPage1 +
        "&target_id=" +
        targetId
      )
      .subscribe((res: any) => {
        console.log(res);
        if (res) {
          this.getPointStructure = res.body.data as PointStructureModel[];
          if (this.getPointStructure.length > 0) {
            this.getPointStructure.forEach((i) => {
              i.isEdit = false;
              i.showDetail = false;
              i.showEdit = false;
              if (i.sku_based_point_structure.length > 0) {
                i.showEdit = true;
                i.sku_based_point_structure.forEach((j) => {
                  j.isEdit = false;
                });
              }
            });
          }
          this.getTargetPageCount1(targetId);
        }
      });
  }
  getAchmntCount() {
    return this.achmnt;
  }

  getAllSaleAchievements(targetId, data) {
    this.apiService
      .getHeaders(
        this.apiConfig.getSalesAchivements +
        "?page=" +
        this.searchPage2 +
        "&target_id=" +
        targetId +
        "&ro_code=" + this.outletCode1
      )
      .subscribe((res: any) => {
        console.log(res);
        if (res) {
          this.getSalesAchievement = res.body.data as SalesAchievementModel[];
          this.getAssignedPaginationCount = res.headers.get(
            "X-Pagination-Total-Count"
          );
          if (this.getSalesAchievement.length > 0) {
            this.achmnt = 1
            this.getSalesAchievement.forEach((i) => {
              i.isEdit = false;
              i.showCheckBox = false;
              i.showDetail = false;
              if (i.sku_wise_sales.length > 0) {
                i.showEdit = true;
                i.sku_wise_sales.forEach((j) => {
                  j.isEdit = false;
                });
              }
            });
          }
          //this.getTargetPageCount2(targetId);
        }
      });
  }

  getTargetPageCount(targetId): void {
    this.apiService
      .getHeaders(this.apiConfig.getLoyaltyTargets + "?page=1&target_id=" + targetId)
      .subscribe((res: any) => {
        this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
        console.log("here", this.getPaginationCount);
      });
  }

  getTargetPageCount1(targetId): void {
    this.apiService
      .getHeaders(this.apiConfig.getPointStructure + "?page=1&target_id=" + targetId)
      .subscribe((res: any) => {
        this.getPaginationCount1 = res.headers.get("X-Pagination-Total-Count");
        console.log("here", this.getPaginationCount1);
      });
  }

  getTargetPageCount2(targetId): void {
    this.apiService
      .getHeaders(this.apiConfig.getSalesAchivements + "?target_id=" + targetId)
      .subscribe((res: any) => {
        this.getAssignedPaginationCount = res.headers.get(
          "X-Pagination-Total-Count"
        );
        console.log("here", this.getAssignedPaginationCount);
      });
  }

  downloadExcel() {
    if (this.userTargetPoint.sku_based) {
      this.exportExcelService.exportExcel(this.products);
    } else {
      this.exportExcelService.exportCategoryExcel(this.brandCategories);
    }
  }

  downloadUpdateExcel() {
    console.log(this.brandCategories, this.loyaltyTargets, "sdfghj")
    this.exportExcelService.exportUpdateCategoryExcel(this.brandCategories, this.loyaltyTargets);
    return
    this.exportExcelService.exportUpdateSKUExcel(this.products, this.loyaltySkuTargets);
  }

  downloadUpdateAchievementExcel() {
    this.exportExcelService.exportUpdateAchvCategoryExcel(this.brandCategories, this.loyaltyTargets);
    this.exportExcelService.exportUpdateAchvSKUExcel(this.products, this.loyaltySkuTargets);

    //this.exportExcelService.exportUpdateAchvCategoryExcelWithTarget(this.brandCategories, this.loyaltyTargets);
  }

  downloadAchievementExcel() {
    this.loading = true;
    this.getAllLoyaltyTarget(this.targetId);
    this.getAllSaleAchievements(this.targetId, this.filteredDetailsForApi1);
  }

  getAllLoyaltyTarget(targetId) {
    this.apiService
      .getHeaders(this.apiConfig.getLoyaltyTargets + "?target_id=" + targetId)
      .subscribe((res: any) => {
        console.log(res);
        this.loyaltyTargetsExcelData = res.body.data as LoyaltyTargetModel[];
        if (this.loyaltyTargetsExcelData.length == 0) {
          this.loading = false;
          this.alertService.error(
            "You can't upload achievements. No Target Found, Please upload the target."
          );
        } else {
          this.exportExcelService.exportAchievementExcel(
            this.products, this.brandCategories,
          );
          this.clearBtn();
        }
      });
  }

  clearBtn() {
    setTimeout(() => {
      this.loading = false; // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

  downloadPointExcel() {
    let outletCount =
      typeof this.userTargetPoint.excel_data != "undefined"
        ? this.userTargetPoint.excel_data.length
        : 0;
    this.exportExcelService.exportPointExcel(this.brandCategories, outletCount);
  }

  showTemplate() {
    this.excelChecked = !this.excelChecked;
  }

  getAllBrands() {
    this.apiService.getHeaders(this.apiConfig.configGetBrands).subscribe(
      (res: any) => {
        this.brands = res.body.data as BrandModel[];
        console.log(res.body.data);
        this.brands = this.brands.filter((b) => b.is_loyalty == 1);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  /***********************************************************************/

  /**************LOYALTY TARGET EDIT************/
  // action section
  editRow(index, item) {
    item.isEdit = true;
  }

  editRow2(index, item) {
    item.isEdit = true;
  }

  editRowSKUT(index, item) {
    item.isEdit = true;
  }

  editRowSKUP(index, item) {
    item.isEdit = true;
  }

  updateDataSKUP(index, item, type) {
    item.isEdit = false;
    if (type == "delete") {
      item.status = 0;
    }
    this.updateLoyaltyPointTargetById(item, type, index);
  }

  updateData(index, item, type) {
    item.isEdit = false;
    if (type == "delete") {
      item.status = 0;
    }
    this.updateLoyaltyTargetById(item, type, index);
  }

  updateDataSKUT(index, item, type) {
    item.isEdit = false;
    if (type == "delete") {
      item.status = 0;
    }
    this.updateLoyaltyProductTargetById(item, type, index);
  }

  updateData2(index, item, type) {
    item.isEdit = false;
    if (type == "delete") {
      item.status = 0;
    }
    this.updateSalesTargetById(item, type, index);
  }

  updateLoyaltyProductTargetById(
    item: LoyaltyTargetProductWiseModel,
    type,
    index
  ) {
    this.apiService
      .put(this.apiConfig.updateLoyaltyProductTarget + "?id=" + item.id, item)
      .subscribe((res: any) => {
        if (res.status == 201 || res.status == 200) {
          if (type == "edit") {
            this.toast.Success("Updated successfully");
            this.alertService.success(res.data.message);
            this.clearSuccess();
          } else if (type == "delete") {
            this.getLoyaltyTargets.splice(index);
            this.toast.Success("Deleted successfully");
          }
        }
      });
  }

  updateLoyaltyPointTargetById(
    item: PointStructureProductWiseModel,
    type,
    index
  ) {
    this.apiService
      .put(this.apiConfig.updatePointsProductTarget + "?id=" + item.id, item)
      .subscribe((res: any) => {
        if (res.status == 201 || res.status == 200) {
          if (type == "edit") {
            this.toast.Success("Updated successfully");
            this.alertService.success(res.data.message);
            this.clearSuccess();
          } else if (type == "delete") {
            this.getLoyaltyTargets.splice(index);
            this.toast.Success("Deleted successfully");
          }
        }
      });
  }

  updateLoyaltyTargetById(item: LoyaltyTargetModel, type, index) {
    this.apiService
      .put(this.apiConfig.updateLoyaltyTarget + "?id=" + item.id, item)
      .subscribe((res: any) => {
        if (res.status == 201 || res.status == 200) {
          if (type == "edit") {
            this.toast.Success("Updated successfully");
            this.alertService.success(res.data.message);
            this.clearSuccess();
          } else if (type == "delete") {
            item.status = 0;
            this.getLoyaltyTargets.splice(index, 1);
            this.toast.Success("Deleted successfully");
          }
        }
      },
        (err) => {
          console.log(err);
          this.toast.Error(err);
        }
      );
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

  updateSalesTargetById(item: SalesAchievementModel, type, index) {
    this.apiService
      .put(this.apiConfig.updateSalesAchievement + "?id=" + item.id, item)
      .subscribe((res: any) => {
        if (res.status == 201 || res.status == 200) {
          if (type == "edit") {
            this.toast.Success("Updated successfully");
            this.alertService.success("Deleted successfully");
            this.clearSuccess();
          } else if (type == "delete") {
            this.getSalesAchievement.splice(index);
            this.alertService.success("Deleted successfully");
            this.clearSuccess();
            this.toast.Success("Deleted successfully");
          }
        }
      });
  }
  redirectTodashboard() {
    this.router.navigateByUrl("/hubAdmin/list-target-achievements");
  }
  /**************************/

  /**************************/
  // action section
  editRow1(index, item) {
    item.isEdit = true;
  }

  updateData1(index, item, type) {
    item.isEdit = false;
    if (type == "delete") {
      item.status = 0;
    }
    this.updatePointStructureByID(item, type, index);
  }

  updatePointStructureByID(item: PointStructureModel, type, index) {
    this.apiService
      .put(this.apiConfig.updatePointsTarget + "?id=" + item.id, item)
      .subscribe((res: any) => {
        if (res.status == 201 || res.status == 200) {
          if (type == "edit") {
            this.toast.Success("Updated successfully");
            this.alertService.success(res.data.message);
            this.clearSuccess();
          } else if (type == "delete") {
            this.getPointStructure.splice(index);
            this.alertService.success(res.data.message);
            this.clearSuccess();
            this.toast.Success("Deleted successfully");
          }
        }
      });
  }

  /******************************************************************/
  checkedEvent: boolean = false;

  BulkAll() {
    this.checkedEvent = !this.checkedEvent;
    if (typeof this.checkedEvent != "undefined") {
      if (this.checkedEvent == true) {
        this.selectAll();
      } else {
        this.DeselectAll();
      }
    }
  }

  selectAll() {
    this.getSalesAchievement.forEach((r) => {
      if (r.approve_status == 0) {
        r.bulkChecked = true;
      }
    });
  }

  DeselectAll() {
    this.getSalesAchievement.forEach((r) => {
      if (r.approve_status == 0) {
        r.bulkChecked = false;
      }
    });
  }

  approveSalesAchievement() {
    let data = this.getSalesAchievement
      .filter((i) => i.bulkChecked == true)
      .map((m) => m.id);
    if (data.length > 0) {
      let approvedData: ApprovedAchievementModel = new ApprovedAchievementModel();
      approvedData.records = data;
      approvedData.task_id = this.targetId;
      this.ApproveSalesAchievements(approvedData);
    }
  }

  ApproveSalesAchievements(data: ApprovedAchievementModel) {
    this.apiService
      .post(this.apiConfig.approveSalesAchievement, data)
      .subscribe((res: any) => {
        if (res.status == 201 || res.status == 200) {
          this.toast.Success("Achievements Approved Successfully");
          this.getAllSaleAchievements(data.task_id, this.filteredDetailsForApi1);
        }
      });
  }
  /**
   * kailash_dev
   */
  openAddBrand(status) {
    if (status == "target") {
      this.sildeModelPlaceHolder = "Targets";
    } else {
      this.sildeModelPlaceHolder = "Points";
    }
    const filterBrands = this.brands.filter((i) => i.is_loyalty == 1);
    const Brands = filterBrands.map((i) => i.sku);
    Brands.forEach((ele) =>
      this.filteredBrands.push({ name: ele, point: null })
    );
    console.log([Brands, this.filteredBrands]);
  }
  showuploadTemplateModal(targetModal, status) {
    this.openExcelDetails.status = status;
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }
  closeoptionModel() {
    this.tempOptionModel.close();
  }
  downloadExcelSheet(status) {
    if (status == 1) {
      this.downloadExcel();
    } else if (status == 2) {
      this.downloadPointExcel();
    }
  }

  xlsxView(data) {

    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        if (result.length > 0) {
          this.userTargetPoint.excel_data = result;
        }
        else {
          this.userTargetForm.controls['userTargetExcel'].reset();
        }
      },
      (reason) => { }
    );
  }


  uploadMultiData(data) {
    this.enableUploadDiv(data);
  }

  uploadMultiData1(data) {
    this.enableUploadDiv1(data)
  }

  enableUploadDiv(data) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: this.apiConfig.createLoyalty,
      module: "Target & Achievements",
      zip: "no",
      excelname: this.excelFileName,
    });
  }

  enableUploadDiv1(data) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: this.apiConfig.createSalesAchivement,
      module: "Target & Achievements",
      zip: "no",
      excelname: this.excelFileName,
    });
  }

  mapTargetAndPoints(status, from) {
    if (from) {
      let sendDetails: any = {};
      let sendApi: string;
      if (from.toLowerCase() == "targets") {
        sendApi = "";
        console.log("Targets");
        sendDetails.assignDetails = this.filteredDetailsFortarget;
      } else if (from.toLowerCase() == "points") {
        sendApi = "";
        console.log("Points");
        sendDetails.assignDetails = this.filteredDetailsForpoint;
      }
      if (status == 1) {
        // generic
        sendDetails.generic = this.addbrandCheck.genericPoint;
      } else if (status == 2) {
        let enteredDetails = this.filteredBrands.filter(
          (element) => element.point != null
        );
        console.log("enteredDetails::", enteredDetails);
        sendDetails.individual = enteredDetails;
        // individual
      }
      console.log([sendDetails, status, from]);
    }
  }






  editPointConfigs() {


    this.disable = false
  }

  onChangePointsConfig() {

    this.userTargetPoint.points_based = !this.userTargetPoint.points_based;
    if (!this.userTargetPoint.points_based) {
      this.userTargetForm.controls['channel_id'].disable();
      this.userTargetForm.controls['region_id'].disable();
      this.userTargetForm.controls['items'].disable();
    }
    else {
      this.userTargetForm.controls['channel_id'].enable();
      this.userTargetForm.controls['region_id'].enable();
      this.userTargetForm.controls['items'].enable();
    }
  }

  loyaltyTargets: any[];
  loyaltySkuTargets: any[];
  getPointsCalcStatus() {
    if (this.pointsCalcStatus == "")
      this.pointsCalcStatus = "Points Calculation Request not submitted"
    return this.pointsCalcStatus;
  }

  getPointsCreditStatus() {
    if (this.pointCreditStatus == "")
      this.pointCreditStatus = "Points Credit Request not submitted"
    return this.pointCreditStatus;
  }

  getAllLoyaltyTargetReportsCategories() {
    this.apiService.getHeaders(this.apiConfig.getTargetList + "?target_id=" + this.targetId).subscribe(
      (res: any) => {
        this.loyaltyTargets = res.body.data.category_wise as any[];
        this.loyaltySkuTargets = res.body.data.sku_wise as any[];
        this.pointsCalcStatus = res.body.data.target_run_status_pointscalc;
        this.pointCreditStatus = res.body.data.target_run_status_pointscredit;
        this.getPointsCalcStatus();
        console.log("calc status", this.pointsCalcStatus)
        console.log("calc status", this.pointCreditStatus)
      },
      (err) => {
        console.log(err);
      }
    );
  }

  onChangePointStructure() {
    console.log(this.userTargetPoint)
    this.userTargetPoint.sku_based = !this.userTargetPoint.sku_based;
  }

  isNameDup() {
    const validator: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls
        .map(control => control.value);
      const names = totalSelected.map(value => value.brand_id)
      const hasDuplicate = names.some(
        (name, index) => names.indexOf(name, index + 1) != -1
      );
      return hasDuplicate ? { duplicate: true } : null;
    }
    return validator;
  }

  isNameDup1() {
    const validator: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls
        .map(control => control.value);
      const names = totalSelected.map(value => value.brand_id)
      const hasDuplicate = names.some(
        (name, index) => names.indexOf(name, index + 1) != -1
      );
      return hasDuplicate ? { duplicate: true } : null;
    }
    return validator;
  }

  outletCode: any = "";
  outletCode1: any = "";
  filteredDetails: any = {
    search_string: "",
    regions: [],
    states: [],
    tse: [],
    m2: [],
    m3: [],
    tmm: [],
    start_date: "",
    end_date: "",

  };
  filteredDetailsForApi: any = {
    search_string: "",
    regions: [],
    states: [],
    tse: [],
    m2: [],
    m3: [],
    tmm: [],
    start_date: "",
    end_date: "",
  };

  filteredDetailsForApi1: any = {
    search_string: "",
    regions: [],
    states: [],
    tse: [],
    m2: [],
    m3: [],
    tmm: [],
    start_date: "",
    end_date: "",
  };

  filterListOfRecords() {
    try {
      this.filteredDetailsForApi.search_string = this.outletCode;
    } catch (error) { }
    this.getAllApi(this.targetId, this.filteredDetailsForApi);
  }

  filterListOfRecords1() {
    try {
      this.filteredDetailsForApi1.search_string = this.outletCode1;
    } catch (error) { }
    this.getAllSaleAchievements(this.targetId, this.filteredDetailsForApi);
  }
  onChange(event) {

    let year = moment(this.date).format("YYYY")
    let month = parseInt(moment(this.date).format("MM"))
    let selectMonth = moment(this.targetModel.start_date.month).format("MM");
    // let isdisplay = [true,true,true,true,true,true,true,true,true,true,true,true]
    if (year == event) {
      for (let i = 0; i < month - 1; i++) {
        this.isdisplay[i] = false;
        this.targetModel.start_date.month = ""
      }
      console.log(this.isdisplay)
    }
    else {
      for (let i = 0; i <= 11; i++) {
        this.isdisplay[i] = true;
        // this.targetModel.start_date.month =""
      }
      console.log(this.isdisplay)
    }
  }
  filteredDetails1: any = {
    search_string: "",
    regions: [],
    states: [],
    channels: [],
    posm_types: [],
    posm_elements: [],
  };
  states_list: StateModel[];
  StatesfilterByRegion: StateModel[];

  async selectedItem1(data, serviceId) {
    console.log("!@#$%", ...this.states_list);
    //debugger
    switch (serviceId) {
      case 1: // roles
        this.filteredDetails1.regions = await data;
        this.StatesfilterByRegion = [];
        let item = data;
        item.forEach((element) => {
          this.StatesfilterByRegion.push(
            ...this.states_list.filter(
              (s) => s.region_id == element.id && s.state_year == 2021
            )
          );
        });
        break;
      case 2: // State
        this.filteredDetails1.states_list = await data;
        break;
      default:
        break;
    }
  }
}
